module.exports = __webpack_public_path__ + "img/dead-grey-trunk-05.452dc709.png";